import React, {Component} from 'react';
import {Button, TextField, MenuItem, Grid} from 'material-ui';
import {getSearchValues} from '../../components/helpers/helpers';

class FaqsFilters extends Component {

    render() {
        const {
            faqsTypes,
            classes,
            setFilter,
            filters,
            onFiltersApply,
            resetFilters,
        } = this.props;

        return (
            <Grid>
                <Grid item xs={12} className={classes.container} noValidate autoComplete="off">
                    <Grid container className={classes.containerLineOne}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="title"
                                label="Search by title"
                                className={classes.textField}
                                value={getSearchValues(filters, 'title') || ''}
                                onChange={event => {
                                    setFilter('title', event.target.value);
                                }}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="body"
                                label="Search by body"
                                className={classes.textField}
                                value={getSearchValues(filters, 'body') || ''}
                                onChange={event => {
                                    setFilter('body', event.target.value);
                                }}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="faqs-types"
                                select
                                label="FAQ Type"
                                className={classes.textField}
                                value={getSearchValues(filters, 'faq_type_id') || -1}
                                onChange={event => {
                                    setFilter('faq_type_id', event.target.value);
                                }}
                                margin="normal"
                            >
                                <MenuItem key={-1} value={-1} className={classes.selectMenuItemFilters}> - please select - </MenuItem>
                                {faqsTypes.map(option => (
                                    <MenuItem key={option.id} value={option.id} className={classes.selectMenuItemFilters}>
                                        {option.display_name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className={classes.containerLineTwo}>
                    <Button variant="raised" color="primary" className={classes.filterButton} onClick={onFiltersApply} style={{marginRight: 15 }}>
                        Filter
                    </Button>
                    <Button variant="raised" color="default" className={classes.filterButton} onClick={event => resetFilters(filters)}>
                        Reset Filters
                    </Button>
                </Grid>
            </Grid>
        )
    }
}

export default FaqsFilters;


// WEBPACK FOOTER //
// ./src/containers/faqs/FaqsFilters.jsx